import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { telHref, waHref } from "../lib/site";

export default function FloatingCTAs() {
  return (
    <div className="fixed right-4 bottom-4 z-40 flex flex-col gap-3" data-testid="floating-ctas">
      <a
        href={waHref()}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        data-testid="floating-whatsapp"
        className="relative animate-pulse-ring w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] grid place-items-center shadow-xl text-white transition hover:scale-110"
      >
        <MessageCircle size={26} />
      </a>
      <a
        href={telHref}
        aria-label="Call"
        data-testid="floating-call"
        className="w-14 h-14 rounded-full bg-orange-600 hover:bg-orange-700 grid place-items-center shadow-xl text-white transition hover:scale-110"
      >
        <Phone size={24} />
      </a>
    </div>
  );
}
